export enum NotificationsReservoir {
  NOTIFICATIONS = 'NOTIFICACION_Nuevo_Contenido',
}
